import { Button } from "@/components/ui/button";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { BarChart, Table } from "lucide-react";
import HistoryFilter from "./HistoryFilter";

const ControlBar = ({
  activeView,
  onViewChange,
  showViewButtons = true,
  showTitle = true,
}: {
  activeView: string;
  onViewChange: (view: "graph" | "table") => void;
  showViewButtons?: boolean;
  showTitle?: boolean;
}) => {
  return (
    <div
      className={`flex  items-center bg-white pr-1 ${
        showTitle ? "justify-between" : "justify-end"
      }`}
    >
      {showTitle && (
        <div className="flex items-center ">
          {!showTitle ? null : (
            <>
              <h2 className="text-xl font-semibold">Evaluation History</h2>
              <BasicTooltip content="Only batch runs with valid scores appear here.">
                <Button variant={"link"} size="tinyIcon">
                  <InformationCircleIcon className="h-4 w-4" />
                </Button>
              </BasicTooltip>
            </>
          )}
        </div>
      )}
      {showViewButtons && (
        <div className="ml-auto mr-2 flex items-center rounded-md border border-gray-200 bg-gray-50 p-0.5">
          <BasicTooltip content="Chart View">
            <Button
              variant={activeView === "graph" ? "default" : "ghost"}
              onClick={() => onViewChange("graph")}
              size="sm"
              className={`${
                activeView === "graph" ? "shadow-sm" : "hover:bg-gray-100"
              } rounded-md px-3`}
            >
              <BarChart size={16} className="mr-1" />
              <span className="text-xs">Chart</span>
            </Button>
          </BasicTooltip>
          <BasicTooltip content="Table View">
            <Button
              variant={activeView === "table" ? "default" : "ghost"}
              onClick={() => onViewChange("table")}
              size="sm"
              className={`${
                activeView === "table" ? "shadow-sm" : "hover:bg-gray-100"
              } rounded-md px-3`}
            >
              <Table size={16} className="mr-1" />
              <span className="text-xs">Table</span>
            </Button>
          </BasicTooltip>
        </div>
      )}
      <HistoryFilter />
    </div>
  );
};

export default ControlBar;
